import { render, staticRenderFns } from "./Politicas.vue?vue&type=template&id=f85de93c&scoped=true"
import script from "./Politicas.vue?vue&type=script&lang=ts"
export * from "./Politicas.vue?vue&type=script&lang=ts"
import style0 from "./Politicas.vue?vue&type=style&index=0&id=f85de93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85de93c",
  null
  
)

export default component.exports